module.exports = __webpack_public_path__ + "images/dogPow.2fd0e18d.svg";